export const isUrl = (value: string) =>
  /^(https?:\/\/|www\.)/.test(value || '');
